import React from 'react';

const UniSeparator = (props) => {
  return (
    <div className="uniformcompo__form-separator" >
      <div className="uniformcompo__form-separator__line-core"></div>
    </div>
  );
};

export default UniSeparator;